// Official brand logo. Cropped to the coral circle via rounded container + slight scale.
export const Logo = ({ size = 40, className = "" }) => (
  <span
    className={`relative inline-block overflow-hidden rounded-full bg-coral shrink-0 ${className}`}
    style={{ width: size, height: size }}
  >
    <img
      src="/logo.png"
      alt="The Pet Shopping Co"
      className="absolute inset-0 w-full h-full object-cover"
      style={{ transform: "scale(1.32)" }}
    />
  </span>
);
